(() => {
  const init = (root) => {
    if (!root || root.dataset.featuredCardsInit === '1') return;
    root.dataset.featuredCardsInit = '1';
    if (!window.Swiper) return;

    const sliderEl = root.querySelector('[data-featured-cards-swiper]');
    if (!sliderEl) return;

    const scrollable = sliderEl.dataset.scrollable === 'true';
    const prevEl = root.querySelector('.featured-cards__nav--prev');
    const nextEl = root.querySelector('.featured-cards__nav--next');
    let instance = null;
    let mode = null;

    const destroy = () => {
      if (instance) {
        instance.destroy(true, true);
        instance = null;
        mode = null;
      }
    };

    const apply = () => {
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const wantMode = isMobile ? 'mobile' : (scrollable ? 'desktop' : 'static');
      if (wantMode === mode) return;
      destroy();
      if (wantMode === 'mobile') {
        instance = new Swiper(sliderEl, {
          slidesPerView: 2.5,
          spaceBetween: 12,
          speed: 500,
          freeMode: false,
        });
      } else if (wantMode === 'desktop') {
        instance = new Swiper(sliderEl, {
          slidesPerView: 5,
          slidesPerGroup: 1,
          spaceBetween: 24,
          speed: 600,
          navigation: { prevEl, nextEl },
        });
      }
      mode = wantMode;
    };

    apply();
    let raf = 0;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(apply);
    });
  };

  const boot = () => {
    document.querySelectorAll('.featured-cards').forEach(observe);
  };

  const observe = (root) => {
    if (!root || root.dataset.featuredCardsInit === '1' || root.dataset.featuredCardsObserve === '1') return;
    root.dataset.featuredCardsObserve = '1';

    let observer = null;
    const start = () => {
      root.removeAttribute('data-featured-cards-observe');
      if (observer) observer.disconnect();
      init(root);
    };

    root.addEventListener('pointerenter', start, { once: true, passive: true });
    root.addEventListener('focusin', start, { once: true });
    root.addEventListener('touchstart', start, { once: true, passive: true });

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) start();
        });
      }, { rootMargin: '400px 0px' });
      observer.observe(root);
    } else {
      start();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init on theme editor / dynamic section changes
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector?.('.featured-cards') || (e.target.classList?.contains('featured-cards') ? e.target : null);
    if (root) observe(root);
  });
})();
